
<div class="card">

  <div class="card-header">
    <h4 class="card-title">{{title | translate}}</h4>
  </div>

  <div class="card-body">
    <ng-content></ng-content>
  </div>

  <div class="card-footer">
    <span class="float-left">
      @if (showGoBackButton && showButtons) {
        <button (click)="goBack()" class="btn btn-outline-secondary">{{'common/buttons/go-back' | translate}}</button>
      }
      @if (showGoBackButton && showButtons) {
        <span class="mx-1"></span>
      }
      @if (showButtons && showSubmit) {
        <button (click)="submit()" [disabled]="formGroup.invalid || !formGroup.dirty || deleting" class="btn btn-primary">{{'common/buttons/submit' | translate}}</button>
      }
      @if (showButtons) {
        <span class="mx-1"></span>
      }
      @if (showButtons && showDelete) {
        <button (click)="delete()" [hidden]="!id" [disabled]="deleting" class="btn btn-danger">{{'common/buttons/delete' | translate}}</button>
      }
    </span>
    <ng-content select="[commands]"></ng-content>
  </div>

</div>
